import * as PIXI from 'pixi.js';
import { Scene } from "pixi-scenegraph";

import { createMenuItem, style } from '@/ui/menu-builder';
import { HEIGHT, WIDTH } from "@/constants";
import { Fx } from "@/audio/audio";
import { PlotComponent } from '@/components/plot-component';
import { store } from "@/model/store";
import { shake, popIn, melt } from '@/util/tween';
import game from "@/model/game";

const fontStyle = new PIXI.TextStyle({
    fontFamily: 'Arial',
    fontSize: 27,
    fontStyle: 'italic',
    fontWeight: 'bold',
    fill: ['#ffffff', '#FFD700'], // gradient
    stroke: '#4a1850',
    strokeThickness: 5,
    dropShadow: true,
    dropShadowColor: '#000000',
    dropShadowBlur: 4,
    dropShadowAngle: Math.PI / 6,
    dropShadowDistance: 6,
    wordWrap: true,
    wordWrapWidth: 440,
    lineJoin: 'round',
    align: 'left'
});

const BUTTON_HEIGHT = 40, PADDING = BUTTON_HEIGHT * 0.5;

export class ResultsScene extends Scene {

    chartStats = {
        id: 'CHART ID really long name 20 20',
        progress: '0%',
        newProgress: '0%'
    }

    constructor() {
        super("results"); // this is the scene name
        this.initBackground();
        const panel = new PIXI.Sprite(PIXI.Texture.WHITE);
        panel.anchor.set(0.5, 0.5);
        panel.position.set(WIDTH / 2, HEIGHT / 2);
        panel.scale.set(46, 46);
        panel.tint = 0x333333;
        this.addChild(panel);

        const back = createMenuItem({
            text: 'Select new song', 
            yCoord: 760,
            xCoord: WIDTH / 2 - 140,
            width: 230,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'select-song'
            }
        });

        this.addChild(back);
        const restart = createMenuItem({
            yCoord: 760,
            xCoord: WIDTH / 2 + 140,
            width: 230,
            text: 'Restart last song', 
            clickActionName: 'RESTART'
        });
        this.addChild(restart);
        const text = new PIXI.Text(
            '', fontStyle
        );
        this.chartStatsText = text;
        text.position.set(WIDTH / 2 - 350, 120);
        text.anchor.set(0, 0);
        this.addChild(text);

        const averageGrade = new PIXI.Text('HERE', {
            ...fontStyle,
            fontSize: 120,
            fill: ['#ffffff', '#FF00aa'], // gradient
        });
        averageGrade.position.set(760, 400);
        averageGrade.alpha = 0.3;
        averageGrade.angle = -16;
        this.averageGrade = averageGrade;
        this.addChild(this.averageGrade);
        this.initHeaders();
    }

    initHeaders() {
        const header = new PIXI.Text('Lets review your results', {
            ...style,
            fontSize: 50,
            align: 'left',
        });
        header.anchor.set(0.5, 0.5);
        header.position.set(320, 40);
        this.addChild(header);
        const sub = new PIXI.Text('Practive will only make you better', {
            ...style,
            align: 'left',
            fontSize: 24
        });
        // sub.anchor.set(0.5, 0.5);
        sub.position.set(20, 80);
        this.addChild(sub);
        this.sub = sub;
    }

    initBackground() {
        const background = PIXI.Sprite.from('public/images/background.jpeg');
        background.width = WIDTH; background.height = HEIGHT;
        this.addChild(background);
    }

    setPayload(chartStats) {
        this.chartStats = chartStats;
        const { id, progress, newProgress, noteHits } = this.chartStats;
        const HITS = {
            Perfect: 0,
            Great: 0,
            Good: 0,
            Bad: 0,
            Late: 0,
            Early: 0
        };
        noteHits.forEach(hit => {
            HITS[hit.grade]++
        });
        const averageValue = Math.max(
            ...Object.keys(HITS).map(k => HITS[k])
        )
        const average = Object.keys(HITS).
            find(grade => HITS[grade] === averageValue);

        this.chartStatsText.text =
            `Hit rate: ${Number(newProgress || 0).toFixed(2)}%\n
        Best hit rate: ${Number(progress || 0).toFixed(2)}%\n
        ${Object.keys(HITS).filter(k => HITS[k] != 0).map(k => HITS[k] + 'x ' + k).join('\n')}
        ${this.chartStats.comboStreak === noteHits.length ? 'FULL COMBO!' : 'Max Combo: ' + Math.max(this.chartStats.comboStreak, this.chartStats.maxCombo)}
        `.replace(/[ ]{4}/g, '');
        this.averageGrade.text = this.chartStats.comboStreak === noteHits.length ? 'FULL COMBO' : average.toUpperCase();
    }

    onReveal() {
        this.chartStatsText.alpha = 0;
        this.averageGrade.alpha = 0;
       
        if (!game.practiceMode) {
            Fx.youWin.play();
            store.updateChartStats(this.chartStats.id, {
                ...this.chartStats,
                noteHits: [],
                grade: this.averageGrade.text,
                played: Date.now()
            });
        }
        
        game.lastSong = { ...game.song };
        game.lastMode = game.mode;
        game.reset();
        if (this.plot) {
            this.removeChild(this.plot)
        }
        const series = (this.chartStats?.noteHits || []).map(
            hit => (['Early', 'Late', 'Bad', 'Good', 'Great', 'Perfect'].indexOf(hit.grade) + 1 ) / 6
        );

        this.plot = new PlotComponent({
            height: 150,
            width: 350,
            series
        })
        this.plot.position.set(WIDTH / 2 + 160, HEIGHT / 2 - 150);
        this.addChild(this.plot);

        Promise.all(this.children.map(sprite => shake(sprite, -40)))
        .then(() => melt(this.chartStatsText, 1500))
        .then(() => melt(this.averageGrade));

    }

}